import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: {
    hostedProjects: null,
    applications: null,
    likedProjects: null,
    isDrawerOpen: false,
  },
  projects: [],
  projectApplicants: [],
  editNavigate: false,
  isAppModalOpen: false,
};

const manageProjectsSlice = createSlice({
  name: "manageProjects",
  initialState,
  reducers: {
    updateManageProjectsData: (state, action) => {
      state.data = { ...state.data, ...action.payload };
    },
    setProjects: (state, action) => {
      state.projects = action.payload;
    },
    setHostedProjects: (state, action) => {
      state.hostedProjects = action.payload;
    },
    setLikedProjects: (state, action) => {
      state.likedProjects = action.payload;
    },
    setApplications: (state, action) => {
      state.applications = action.payload;
    },
    setProjectApplicants: (state, action) => {
      state.projectApplicants = action.payload;
    },
    setEditNavigate: (state, action) => {
      state.editNavigate = action.payload;
    },
    setIsAppModalOpen: (state, action) => {
      state.isAppModalOpen = action.payload;
    },
    setIsDrawerOpen: (state, action) => {
      state.isDrawerOpen = action.payload;
    },
  },
});

export const {
  updateManageProjectsData,
  setProjects,
  setHostedProjects,
  setLikedProjects,
  setApplications,
  setProjectApplicants,
  setEditNavigate,
  setIsAppModalOpen,
  setIsDrawerOpen,
} = manageProjectsSlice.actions;

export default manageProjectsSlice.reducer;
